export const links = userId => ({
  HOME: {
    link: '/',
    text: 'Home'
  },
  INCIDENTS: {
    link: '/incidents',
    text: 'Incidents'
  },
  ALL_INCIDENTS: {
    link: '/incidents',
    text: 'All Incidents'
  },
  ALERTS: {
    link: '/alerts',
    text: 'Alerts'
  },
  RECENT_CHANGES: {
    link: '/change-events',
    text: 'Recent Changes'
  },
  VISIBILITY: {
    link: '/visibility',
    text: 'Visibility'
  },
  POSTMORTEMS: {
    link: '/postmortems',
    text: 'Postmortems'
  },
  POSTMORTEMS_PREVIEW: {
    link: '/preview/postmortems',
    text: 'Postmortems (preview)'
  },
  RESPONSE_PLAYS: {
    link: '/response_plays',
    text: 'Response Plays'
  },
  CONFERENCE_BRIDGES: {
    link: '/extensions/conference_bridges',
    text: 'Conference Bridges'
  },
  SERVICES: {
    link: '/service-directory',
    text: 'Services',
  },
  SERVICE_DIRECTORY: {
    link: '/service-directory',
    text: 'Service Directory',
  },
  BUSINESS_SERVICES: {
    link: '/business-services',
    text: 'Business Services'
  },
  IMPACT_METRICS: {
    link: '/business_impact_metrics',
    text: 'Impact Metrics'
  },
  EVENT_RULES: {
    link: '/rules/rulesets',
    text: 'Event Rules'
  },
  EVENT_INTELLIGENCE: {
    link: '/event_intelligence',
    text: 'Event Intelligence'
  },
  PEOPLE: {
    text: 'People'
  },
  MY_ON_CALL_SHIFTS: {
    link: '/my-on-call',
    text: 'My On-Call Shifts'
  },
  SCHEDULES: {
    link: '/schedules',
    text: 'On-Call Schedules'
  },
  ESCALATION_POLICIES: {
    link: '/escalation_policies',
    text: 'Escalation Policies'
  },
  USERS: {
    link: '/users',
    text: 'Users'
  },
  TEAMS: {
    link: '/teams',
    text: 'Teams'
  },
  ANALYTICS: {
    text: 'Analytics',
  },
  REPORTS: {
    link: '/reports',
    text: 'Reports'
  },
  REPORTS_PREVIEW: {
    link: '/preview/system-report',
    text: 'Reports (preview)'
  },
  INTELLIGENT_DASHBOARDS: {
    link: '/analytics/dashboards/team-performance',
    text: 'Intelligent Dashboards'
  },
  OPERATIONAL_REVIEWS: {
    link: '/analytics/operational-reviews',
    text: 'Operational Reviews'
  },
  OPERATIONS_HEALTH: {
    link: '/ohms',
    text: 'Operations Health'
  },
  ON_CALL_READINESS: {
    link: '/responder-readiness',
    text: 'On-Call Readiness'
  },
  PD_LABS: {
    link: '/analytics/labs',
    text: 'PD Labs'
  },
  STATUS_DASHBOARD: {
    link: '/status-dashboard',
    text: 'Status'
  },
  NEW_STATUS_DASHBOARD: {
    link: '/statusdashboard',
    text: 'Status'
  },
  SUPPORT: {},
  KNOWLEDGE_BASE: {
    link: 'https://support.pagerduty.com/docs',
    text: 'Knowledge Base'
  },
  COMMUNITY: {
    link: 'https://community.pagerduty.com',
    text: 'Community'
  },
  CONTACT_SUPPORT: {
    link: 'https://support.pagerduty.com/hc/en-us/requests/new',
    text: 'Contact Support'
  },
  WHATS_NEW: {
    id: 'WHATS_NEW'
  },
  DEVELOPER: {
    id: 'DEVELOPER',
  },
  APP_DIRECTORY: {
    link: 'https://www.pagerduty.com/integrations',
    text: 'App Directory'
  },
  EXTENSIONS: {
    link: '/extensions',
    text: 'Extensions'
  },
  ADD_ON_SETTINGS: {
    link: '/extensions/add_ons',
    text: 'Add On Settings'
  },
  DEVELOPER_MODE: {
    link: '/developer/apps',
    text: 'Developer Mode'
  },
  API_ACCESS: {
    link: '/api_keys',
    text: 'API Access'
  },
  DOCUMENTATION: {
    link: 'https://developer.pagerduty.com/docs',
    text: 'Documentation'
  },
  ACCOUNT: {},
  MY_PROFILE: {
    link: `/users/${userId || '*'}`,
    text: 'My Profile'
  },
  ACCOUNT_SETTINGS_OWNER: {
    link: '/account/settings',
    text: 'Account Settings'
  },
  ACCOUNT_SETTINGS_ADMIN: {
    link: '/account/incident_priorities',
    text: 'Account Settings'
  },
  ACCOUNT_SUBSCRIPTIONS: {
    link: '/account/settings/subscription',
    text: 'Subscriptions'
  },
  LOG_OUT: {
    link: '/sign_out',
    text: 'Log Out'
  },
  DEVELOPER_DOCUMENTATION: {
    link: 'https://developer.pagerduty.com/docs/get-started/getting-started/',
    text: 'Documentation'
  },
  API_REFERENCE: {
    link: 'https://developer.pagerduty.com/api-reference',
    text: 'REST API Reference'
  },
  MY_APPS: {
    link: '/developer/apps',
    text: 'My Apps'
  },
});

export const LINK_IDS = Object.keys(links()).reduce((acc, val) => ({
  ...acc,
  [val]: val
}), {});

const getTextLinkMap = userId => Object.values(LINK_IDS).reduce((acc, val) => ({
  ...acc,
  [links(userId)[val].text]: links(userId)[val].link
}), {});

const getLinkArray = userId => Object.values(links(userId)).map(({ link }) => link);

export const getLinkText = linkId => links()[linkId].text;

export const getNavLink = (key, userId = '') => {
  const textLinkMap = getTextLinkMap(userId);
  return textLinkMap[key] !== 'undefined' ? textLinkMap[key] : false;
};

export const isActiveLink = (item, userId) => {
  /* eslint-disable prefer-template */
  const path = window.location.pathname;

  if (!item || (item === '/' && path !== '/')) return false;

  const escapedItem = item.replace(/[\\[.+*?(){|^$]/g, '\\$&');
  const rx = '(.+)?' + escapedItem + '((\\/?\\?.+)|\\/)?$';
  const linkMatch = new RegExp(rx, 'i');
  const match = linkMatch.test(path);

  // child links should activate their parent if they are not in the link list
  let activateParent = false;
  if (item !== '/' && path.indexOf(item) === 0) {
    activateParent = !getLinkArray(userId).includes(path);
  }

  return match || activateParent;
};

export const isActiveSection = (sectionItems, userId) => {
  if (sectionItems.length === 0) return false;
  return (
    sectionItems
      .map(p => getNavLink(p, userId))
      .filter(l => isActiveLink(l, userId)).length > 0
  );
};
